import general from './general';

const partnersPage = {
    init: function() {
        document.addEventListener('DOMContentLoaded', () => {
            this.partnersPage();
        });
    },

    partnersPage: function() {
        if (!$(".site-wrapp_partners").length) return;

        var direction = null;
        var scroll = new LocomotiveScroll({
            el: document.querySelector("[data-scroll-container]"),
            smooth: true,
            class: "is-inview",
            getDirection: true,
        });
        scroll.on("scroll", (event) => {
            direction = event.direction;
        });

        if ($(window).width() > 767) {
            scroll.on("call", (func, state, event) => {
                if (direction === "down" && state === "enter") {
                    $(`.${func}`).addClass("show");
                    if (func === "partners__phone") {
                        $(".partners__first-img").addClass("hidden");
                    }
                } else if (direction === "up" && state === "exit") {
                    $(`.${func}`).addClass("hidden");
                    if (func === "partners__phone") {
                        $(".partners__first-img").addClass("show");
                        setTimeout(function() {
                            $(".partners__first-img").removeClass("hidden show");
                        }, 500);
                    }
                    setTimeout(function() {
                        $(`.${func}`).removeClass("show hidden");
                    }, 500);
                }
            });
        } else {
            scroll.on("call", (func, state, event) => {
                if (func === "header-show") {
                    if (state === "enter") {
                        $(".header_hidden").addClass("show");
                    }
                    if (state === "exit") {
                        $(".header_hidden").removeClass("show");
                    }
                }
            });
        }

        if ($(".partners_mobile").length !== 0) {

            window.onload = function() {
                setTimeout(function() {
                    scroll.scrollTo($(".partners__slider")[0], {
                        duration: 3000,
                        offset: 20,
                    });
                }, 3000);
            }

            const partners__slider = $(".partners__slider");
            partners__slider.flickity({
                cellAlign: "left",
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                on: {
                    ready: function() {
                        $(".partners__slider").addClass("ready");
                        $(".partners__bottom").addClass("ready");
                    },
                },
            });

            const partners__slider_item = $(".partners__slider-item");
            var countSlide = partners__slider_item.length - 1;

            partners__slider_item.each(function(index) {
                $(".partners__slider-dots").append(`<div class="partners__slider-dot" data-index="${index}"></div>`);
            });

            dotsChange(0);

            partners__slider.on("change.flickity", function(event, index) {
                dotsChange(index);
            });

            partners__slider.on("scroll.flickity", function(event, progress) {
                var ratio = 0.6 * 0.7;
                $(".partners__slider-decor.left").css({
                    left: (0.5 - (0.5 + progress * countSlide) * ratio) * 100 + "%",
                });
                $(".partners__slider-decor.right").css({
                    right: (0.5 - (0.5 + progress * countSlide) * ratio) * 100 + "%",
                });
                $(".partners__slider-rub img").css({
                    transform: `rotate(${(0.5 - (0.2 + progress * countSlide) * ratio) * 100}deg)`,
                });
                $(".partners__slider-card img").css({
                    transform: `rotate(${(0.845 - (0.2 + progress * countSlide) * ratio) * 100}deg)`,
                });
                $(".partners__slider-plane img").css({
                    transform: `rotate(${(1.35 - (0.2 + progress * countSlide) * ratio) * 100}deg)`,
                });
            });

            function dotsChange(index) {
                $(".partners__slider-dot").removeClass("active close distant");
                $(`.partners__slider-dot[data-index='${index}']`).addClass("active");
                $(`.partners__slider-dot[data-index='${index - 1}']`).addClass("close");
                $(`.partners__slider-dot[data-index='${index + 1}']`).addClass("close");
                $(`.partners__slider-dot[data-index='${index - 2}']`).addClass("distant");
                $(`.partners__slider-dot[data-index='${index + 2}']`).addClass("distant");
            }
        }
    },
};

general.init();
partnersPage.init();
